import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Grid, Header, Image, Message, Segment } from 'semantic-ui-react';
import logo from '../assets/svgs/funeral-live-logo.png';

import { loginUser } from '../actions/userActions';

const LoginPage = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
  <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
    <Grid.Column style={{ maxWidth: 600 }}>
      <Header as='h2' color='black' textAlign='center'>
        <Image src={logo} style={{ width: 150 }} /> Log in to your account
      </Header>
        {props.user.error && 
          <Message negative>
            <Message.Header>{props.user.error.message}</Message.Header>
          </Message>
        }
        <Segment stacked>
          <Input 
            fluid
            icon='user'
            iconPosition='left'
            placeholder='Email address'
            value={email}
            onChange={(e) => setEmail(e.target.value)} />
          <Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='Password'
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            color='blue'
            fluid
            size='large'
            disabled={!email || !password}
            onClick={() => props.loginUser(email, password, props.history)}>
              Login
          </Button>
        </Segment>
      <Message>
        Forgot your password? <b style={{ cursor: 'pointer', color: 'blue' }} onClick={() => props.history.push('/resetPassword')}>Click here</b>
      </Message>
    </Grid.Column>
  </Grid>
  );
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = {
  loginUser
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
